module.exports = __webpack_public_path__ + "img/object-list.f0f6250b.svg";